import { customAxios } from "./customAxios";

/**
 * 접속이력 추가
 * @returns 
 */
export const createAccessLog = async ({
    menuId,
    menuName,
    pageUrl,
    privateIpAddress
}) => {
    const response = await customAxios.post(
        "/api/logs/access",
        {
            menuId,
            menuName,
            pageUrl,
            privateIpAddress
        }
    );

    return response.data;
};

export const updateHeartbeat = async (id) => {
    return await customAxios.patch(
        `/api/logs/access/${id}/heartbeat`
    );
};

export const createAuditLog = async({
    menuId,
    menuName,
    pageUrl,
    privateIpAddress,
    
    actionType,
    targetType,
    targetId,
    targetName,
    
    apiUrl,
    requestMethod,
    summary,
    payload
}) => {
    const response = await customAxios.post(
        "/api/logs/audit",
        {
            menuId,
            menuName,
            pageUrl,
            privateIpAddress,
            
            actionType,
            targetType,
            targetId,
            targetName,
            
            apiUrl,
            requestMethod,
            summary,
            payload
        }
    );

    return response.data;
}

/**
 * 접속현황대시보드
 * @param {*} query 
 * @returns 
 */
export const getLogsDashboard = async(query)=>{
  const res = await customAxios.get('/api/logs/dashboard', {params : query});
  //console.log(res);
  if (res && res.data) {
      //return Object.values(res.data);
      return res.data;
  }
  return null;
}

/**
 * 메뉴사용통계
 * @param {*} query 
 * @returns 
 */
// export const getMenuStatistics = async(query)=>{
//   const res = await customAxios.get('/api/logs/menuStatistics', {params : query});
//   //console.log(res);
//   if (res && res.data) {
//       //return Object.values(res.data);
//       return res.data;
//   }
//   return null;
// }

/**
 * 검색용 사용자 목록(SELECT)
 * @param {*} query 
 * @returns 
 */
export const getSelectUsers = async()=>{
  const res = await customAxios.get('/api/logs/users');
  if (res && res.data) {
      return res.data;
  }
  return null;
}

/**
 * 접속이력목록
 * @param {*} query 
 * @returns 
 */
export const getAccessLogs = async(query)=>{
  const res = await customAxios.get('/api/logs/access', {params : query});
  if (res && res.data) {
      return res.data;
  }
  return null;
}

/**
 * 접속이력 엑셀다운로드
 * @param {*} query 
 * @returns 
 */
// export const downloadAccessLogExcel = async(query)=>{
//     return {
//         "_embedded": {
//             "accessLogs": [
//                 { "id": 1, "accessTime": "2026-06-11 10:15", "user": { "id": 1, "name" : "홍길동"}, "menu" : { "id": 18110, "name" : "menu.cmms.management.basic.equipment"} , "url" : "/setting/basic/equipment", "ip" : "192.168.0.1" },
//                 { "id": 2, "accessTime": "2026-06-11 10:28", "user": { "id": 1, "name" : "홍길동"}, "menu" : { "id": 13000, "name" : "menu.cmms.equipment"} , "url" : "/equipment", "ip" : "192.168.0.1" },
//                 { "id": 3, "accessTime": "2026-06-11 10:35", "user": { "id": 2, "name" : "김철수"}, "menu" : { "id": 11000, "name" : "menu.cmms.dashboard"} , "url" : "/dashboard", "ip" : "192.168.0.5" },
//             ]
//         },
//         "_links": {
//             "self": {
//                 "href": "https://platform-cmms-api.dev.safewalks.kr/api/log/accessLogs?page=0&size=20&sort=id,desc"
//             }
//         },
//         "page": {
//             "size": 20,
//             "totalElements": 3,
//             "totalPages": 1,
//             "number": 0
//         }
//     }
// //   const res = await customAxios.get('/api/log/accessLogs', {params : query, responseType: "blob"});
// //   //console.log(res);
// //   if (res && res.data) {
// //       //return Object.values(res.data);
// //       return res.data;
// //   }
// //   return null;
// }

/**
 * 작업이력목록
 * @param {*} query 
 * @returns 
 */
export const getAuditLogs = async(query)=>{
  const res = await customAxios.get('/api/logs/audit', {params : query});
  //console.log(res);
  if (res && res.data) {
      //return Object.values(res.data);
      return res.data;
  }
  return null;
}

/**
 * 작업이력 엑셀다운로드
 * @param {*} query 
 * @returns 
 */
// export const downloadAuditLogExcel = async(query)=>{
//     return {
//         "_embedded": {
//             "auditLogs": [
//                 { "id": 1, "workTime": "2026-06-11 10:12", "user": { "id": 1, "name" : "홍길동"}, "menu" : { "id": 18110, "name" : "menu.cmms.management.basic.equipment"} 
//                    , "actionType" : "C", "targetType" : "EQUIPMENT", "targetName" : "펌프A" },
//                 { "id": 2, "workTime": "2026-06-11 10:15", "user": { "id": 1, "name" : "홍길동"}, "menu" : { "id": 18110, "name" : "menu.cmms.management.basic.equipment"} 
//                    , "actionType" : "U", "targetType" : "EQUIPMENT", "targetName" : "펌프A" },
//                 { "id": 3, "workTime": "2026-06-11 10:25", "user": { "id": 2, "name" : "김철수"}, "menu" : { "id": 11000, "name" : "menu.cmms.management.user"} 
//                    , "actionType" : "D", "targetType" : "USER", "targetName" : "test01" },
//             ]
//         },
//         "_links": {
//             "self": {
//                 "href": "https://platform-cmms-api.dev.safewalks.kr/api/log/auditLogs?page=0&size=20&sort=id,desc"
//             }
//         },
//         "page": {
//             "size": 20,
//             "totalElements": 3,
//             "totalPages": 1,
//             "number": 0
//         }
//     }
// //   const res = await customAxios.get('/api/log/auditLogs', {params : query, responseType: "blob"});
// //   //console.log(res);
// //   if (res && res.data) {
// //       //return Object.values(res.data);
// //       return res.data;
// //   }
// //   return null;
// }

